import React, { useState, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { useDropzone } from 'react-dropzone';
import { Button } from 'reactstrap';
import styled from 'styled-components';
import { ProgressBar, Step } from 'react-step-progress-bar'

import DragZone from 'components/Shared/DragZone';
import { reactSelectStyles } from 'components/Shared/ReactSelectStyles'
import { NextBtn, BackBtn } from 'components/Shared/Button';
import { convertToBase64 } from 'utils';

import { StepContainer } from './StepContainer';

const fileTypes = ['.xlsx', '.xls'];

const MassiveStep = ({ handleBack, onComplete }) => {
    const { t } = useTranslation();
    const [error, setError] = useState(null);
    const [file, setFile] = useState(null);

    const massiveActionOptions = [
        { label: t('contracts.new.massive_as_draft'), value: 'draft' },
        { label: t('contracts.new.massive_send'), value: 'sign' },
    ];

    const [action, setAction] = useState(massiveActionOptions[0]);

    const handleFile = (fileArr) => {
        setError(false);
        setFile(fileArr[0]);
    };

    const onDrop = useCallback(handleFile, []);

    const { open, getInputProps } = useDropzone({
        accept: fileTypes,
        maxSize: 25000000,
        noKeyboard: true,
        multiple: false,
        onDropAccepted: (file) => {
            handleFile(file);
        },
        onDrop,
    });

    const handleOnSubmit = async () => {
        if (!file) {
            setError(true);
        } else {
            const massiveFile = await convertToBase64(file);
            onComplete({ data: massiveFile.base64, action: action.value });
        }
    };

    return (
        <StepContainer
            className="sidebar-new-contract-height"
            title={t('contracts.new.source_massive')}
            form={
                <>  
                    <DragZone
                        imgSrc="/images/listing/createDocument/subir.svg"
                        label={t('common.drag_file')}
                        className=""
                        acceptedFiles={fileTypes}
                        handleFile={handleFile}
                    />
                    <div className="file_pragamtic_container mt-4 mb-1" onClick={open}>
                        <div className="file_name_wrap">
                            <div>{file ? file.name : t('contracts.new.search_document')}</div>
                        </div>
                        <input {...getInputProps()} />
                        <div className="upload-icon-container">
                            <i className="fas fa-upload text-white"></i>
                        </div>
                    </div>
                    <div className="text-muted create-error-smaller">**{t('contracts.listing.only50')}</div>
                    {error ? <div className="create-error-message">{t('errors.MissingFile')}</div> : null}
                    {file ? (
                        <>
                            <div className="document_name_row" key={file.id}>
                                <i
                                    className="fas fa-times text-black"
                                    onClick={() => {
                                        setFile(null);
                                    }}
                                ></i>
                                {file.name}
                            </div>
                            <div className="create-subtitle">{t('contracts.new.action')}</div>
                            <Select
                                styles={reactSelectStyles}
                                cacheOptions
                                className="create-select"
                                options={massiveActionOptions}
                                defaultValue={action}
                                onChange={(val) => setAction(val)}
                                placeholder={t('contracts.new.action')}
                            />
                        </>
                    ) : (
                        ''
                    )}
                </>
            }
            footer={
                <>
                    <BackBtn onClick={handleBack} label={t('form.exit')} />
                    <NextBtn onClick={handleOnSubmit} label={t('contracts.listing.page_next')} />
                </>
            }
        />
    );
};

export default MassiveStep;
